import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { numberWithCommas } from "../helpers";

function generatePageNumbers(currentPage, totalPages) {
  if (totalPages <= 5) {
    return [...Array(totalPages).keys()].map((i) => i + 1);
  } else {
    let pages = [1, 2, "...", totalPages - 1, totalPages];
    if (currentPage > 2 && currentPage < totalPages - 1) {
      pages = [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPages,
      ];
    } else if (currentPage === 2) {
      pages = [1, 2, 3, "...", totalPages];
    } else if (currentPage === totalPages - 1) {
      pages = [1, "...", totalPages - 2, totalPages - 1, totalPages];
    }
    return pages;
  }
}

export default function DataTablePagination({
  currentPage = 1,
  totalPages = 10,
  totalRecords = 0,
  onPageChange = () => {},
  handleChangeRowsPerPage = () => {},
  currentPageData = 10
}) {
  return (
    <div className="docpro_data_table_pagination">
      <div className="docpro_data_table_row">
        <select
          name="row"
          value={currentPageData}
          onChange={(e) => handleChangeRowsPerPage(e.target.value)}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="40">40</option>
          <option value="60">60</option>
          <option value="100">100</option>
          <option value="200">200</option>
          <option value="500">500</option>
        </select>{" "}
        Rows per page
      </div>
      {totalPages > 1 && (
        <div className="docpro_pagination">
          <button
            className="docpro_icon_btn_2 docpro_primary_color"
            style={{ marginRight: "10px" }}
            onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          >
            <ArrowLeft width={20} height={20} />
          </button>
          {generatePageNumbers(currentPage, totalPages).map((page, index) =>
            typeof page === "number" ? (
              <button
                key={index}
                className={`docpro_pagination_number ${
                  currentPage === page ? "active" : ""
                }`}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            ) : (
              <span key={index} className="docpro_pagination_ellipsis">
                {page}
              </span>
            )
          )}
          <button
            className="docpro_icon_btn_2 docpro_primary_color"
            style={{ marginLeft: "10px" }}
            onClick={() =>
              currentPage < totalPages && onPageChange(currentPage + 1)
            }
          >
            <ArrowRight width={20} height={20} />
          </button>
        </div>
      )}
      <div>{`${numberWithCommas(currentPage)}-${numberWithCommas(totalPages)} of ${numberWithCommas(totalRecords)}`}</div>
    </div>
  );
}
